export const FitnessparkTheme = {
  name: 'Fitnesspark Theme',
  themeId: 'fitnesspark',
  colors: {
    brand: {
      primary: {
        100: '#009fec'
      },
      secondary: {
        100: '#4A91C4'
      },
      highlight: {
        100: '#A9DEF8'
      },
      accent: {
        100: '#009fec'
      }
    },
    tints: {
      gray: {
        10: '#f1f1f1',
        25: '#e5e5e5',
        40: '#b2b2b2',
        45: '#969696',
        60: '#666666',
        75: '#4d4d4d',
        90: '#333333',
        100: '#000000'
      }
    }
  },
  backgrounds: {
    tile: '#009fec'
  },
  fonts: {
    families: {
      text: '"Source Sans Pro", "Helvetica", arial, sans-serif',
      heading: '"Source Serif Pro", "Helvetica", arial, sans-serif'
    },
    sizes: {
      text: {
        xsmall: '15px',
        small: '17px',
        huge: '98px'
      },
      heading: {
        xsmall: '20px',
        small: '20px'
      }
    }
  }
};